import { sizePlayer } from "./dimensions"
import { hideEndDisplay } from "./end-display"
import store from "./player-store"
import { updateZoom } from "./player-zoom"
import { player } from "./selectors"
import { clearTrackers, scrollToSlide } from "./player-navigation"
import logEvent from "../tracking/amplitude/log-event"

const icon = $(".fullscreen-icon")

const isFullscreenSupported = () => {
  const user_agent = navigator.userAgent.toLowerCase()
  const hasNativeSupport = document.webkitFullscreenEnabled || document.mozFullScreenEnabled
  const isValidBrowser = /chrome/.test(user_agent) || /firefox/.test(user_agent) || /safari/.test(user_agent)
  // Support native fullscreen for Chrome, Safari and Firefox.
  return hasNativeSupport && isValidBrowser
}

export const isFullscreen = () => {
  return Boolean(document.fullscreenElement || document.webkitCurrentFullScreenElement || document.mozFullScreenElement)
}

const getExitEventName = () => {
  if (document.webkitFullscreenEnabled) {
    return "webkitfullscreenchange"
  } else if (document.mozFullScreenEnabled) {
    return "mozfullscreenchange"
  }
}

const enterNativeFullscreen = () => {
  const container = player[0]
  if (document.webkitFullscreenEnabled) {
    let isSafari = /safari/.test(navigator.userAgent.toLowerCase()) && !/chrome/.test(navigator.userAgent.toLowerCase())
    //  The following code will work for chrome but not for safari,
    // for security reason apple didn't implement this, but the doc is not up to date.
    if (Element && Element.ALLOW_KEYBOARD_INPUT && !isSafari) {
      container.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT)
    } else {
      container.webkitRequestFullScreen()
    }
  } else if (document.mozFullScreenEnabled) {
    container.mozRequestFullScreen()
  }
}

const exitNativeFullscreen = () => {
  if (document.webkitFullscreenEnabled) {
    document.webkitCancelFullScreen()
  } else if (document.mozFullScreenEnabled) {
    document.mozCancelFullScreen()
  }
}

const enterFullscreen = () => {
  const currentIndex = store.index

  clearTrackers()

  hideEndDisplay()
  player.addClass("fullscreen")
  enterNativeFullscreen()

  setTimeout(() => {
    scrollToSlide(currentIndex, true)
  }, 400)

  icon.removeClass("icon-focus").addClass("icon-compress")
}

const exitFullscreen = () => {
  const currentIndex = store.index

  clearTrackers()

  hideEndDisplay()
  player.removeClass("fullscreen")
  exitNativeFullscreen()

  setTimeout(() => {
    scrollToSlide(currentIndex, true)
  }, 400)

  icon.removeClass("icon-compress").addClass("icon-focus")
}

export const handleFullscreenChange = () => {
  if (isFullscreen()) {
    store.fullscreen.isFullscreen = true
    updateZoom(0)
    sizePlayer()
  } else {
    store.fullscreen.isFullscreen = false
    updateZoom(0)
    sizePlayer()
  }
}

const bindEventListeners = () => {
  $("button#fullscreen").on("click", function () {
    logEvent("slideshow_fullscreen_click")

    if (isFullscreen()) {
      exitFullscreen()
    } else {
      enterFullscreen()
    }
  })

  $(document).on(getExitEventName(), function () {
    // After a keyboard-triggered exit event, isFullscreen will return false
    if (!isFullscreen()) {
      exitFullscreen()
    }
  })

  $("#full-screen-download-button .download").on("click", function () {
    exitFullscreen()
  })
}

export const initializeFullscreen = () => {
  if (isFullscreenSupported()) {
    bindEventListeners()
  } else {
    icon.hide()
  }
}
